export const FloatLabel = (() => {
	const handleFocus = (e) => {
		const input = e.target;
		const label = document.querySelector(`label[for='${input.id}']`);
		if (label) {
			label.classList.add("is-floating");
		}
	};

	const handleBlur = (e) => {
		const input = e.target;
		const label = document.querySelector(`label[for='${input.id}']`);

		if (!input.value || input.value === "(___) ___-____") {
			if (label) {
				label.classList.remove("is-floating");
			}
		}
	};

	const init = () => {
		const fields = document.querySelectorAll("input, textarea, select");

		fields.forEach((field) => {
			// Skip checkboxes/radios
			if (field.type === "checkbox" || field.type === "radio") return;
			if (!field.id) return; // Required for matching <label for="...">

			const label = document.querySelector(`label[for='${field.id}']`);
			if (!label) return;

			// Float if already filled
			if (field.value) {
				label.classList.add("is-floating");
			}

			field.addEventListener("focus", handleFocus);
			field.addEventListener("blur", handleBlur);
		});
	};

	return { init };
})();
